import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { STORAGE_URL } from "./util";
import FirebaseHandler from "./index";
import { getDownloadURL, ref } from "firebase/storage";
export var getAudioDownloadUrl = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(articleId, slug) {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        url = STORAGE_URL + "/mp3/" + articleId + "_" + slug + ".mp3";
                        _context.next = 3;
                        return getDownloadURL(ref(FirebaseHandler.storage, url));
                    case 3:
                        return _context.abrupt("return", _context.sent);
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function getAudioDownloadUrl(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
export var getPdfDownloadUrl = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(articleId, slug) {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        url = STORAGE_URL + "/pdf/" + articleId + "_" + slug + ".pdf";
                        _context2.next = 3;
                        return getDownloadURL(ref(FirebaseHandler.storage, url));
                    case 3:
                        return _context2.abrupt("return", _context2.sent);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2);
    }));
    return function getPdfDownloadUrl(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
